import {
    UPDATE_API_KEY,
    UPDATE_API_KEY_FAILURE,
    UPDATE_API_KEY_SUCCESS,
} from 'store/actions/types';

export const updateApiKey = (payload) => {
    return {
        type: UPDATE_API_KEY,
        payload: payload,
    };
};

export const updateApiKeyFailure = (error) => {
    return {
        type: UPDATE_API_KEY_FAILURE,
        error: error,
    };
};

export const updateApiKeySuccess = (response) => {
    return {
        type: UPDATE_API_KEY_SUCCESS,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/apiKeys/updateApiKeys.js